package com.example.positionahead.model

import kotlinx.serialization.Serializable

@Serializable
data class SavedPortfolio(
    val id: String,
    val name: String,
    val colorHex: String = AccountColors.DEFAULT,
    val startDate: String? = null,
    val notes: String = "",
    val isTheoretical: Boolean = false,
    val positions: List<Position> = emptyList(),
    val watchlist: List<WatchlistItem> = emptyList(),
    val goal: FinancialGoal = FinancialGoal(),
)

object AccountColors {
    const val DEFAULT = "#1B8A5A"

    val presets = listOf(
        "#1B8A5A",
        "#2563EB",
        "#DC2626",
        "#9333EA",
        "#EA580C",
        "#0891B2",
        "#CA8A04",
        "#64748B",
    )
}

fun SavedPortfolio.withPositions(positions: List<Position>): SavedPortfolio = copy(positions = positions)

fun SavedPortfolio.withGoal(goal: FinancialGoal): SavedPortfolio = copy(goal = goal)
